import { render, staticRenderFns } from "./config-list.vue?vue&type=template&id=40c77848"
import script from "./config-list.vue?vue&type=script&lang=js"
export * from "./config-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports